import axios from 'axios'

/**
 * 请求函数 - 统一入口
 */
const fddAxios = {
  // 查询审批模板类型列表
  async queryApprovalTypeAxios(axiosData) {
    let result = await axios.get(`/userCenter/businessType/contractList`, axiosData)
    return result.data
  },
  // 立即催办接口
  async remindAxios(axiosData) {
    let result = await axios.post('/userCenter/approval/urge', axiosData)
    return result.data
  },
  // 查询审批模板详情接口
  async queryApprovalTempDetailAxios(axiosData) {
    let result = await axios.post('/userCenter/approval/template/approve-staff-info', axiosData)
    return result.data
  },
  // 发起审批接口
  async approvalInitiateAxios(axiosData) {
    let result = await axios.post('/userCenter/approval/initiate', axiosData)
    return result.data
  },

  //套餐列表
  async getProductList() {
    let result = await axios.post('/ecoSystem/api/v1/temp/charge/detail', {})
    return result.data
  },

  async businessTypeInfo(id) {
    //业务类型详情
    let result = await axios.get(`/userCenter/businessType/typeInfo/${id}`)
    return result.data
  }
}

export default fddAxios
